var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 151175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 151171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 34466"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.453125,
    width: 40,
    height: 40,
    rx: 10,
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.953125,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 9.5,
    stroke: "#A8A8A8",
    strokeOpacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.017 22.7823C25.9203 21.8498 24.8073 21.2849 23.724 22.216L23.0772 22.7788C22.6039 23.1873 21.724 25.096 18.3219 21.2053C14.9206 17.3196 16.9447 16.7146 17.4186 16.3096L18.069 15.7462C19.1466 14.8129 18.7399 13.6381 17.9627 12.4288L17.4937 11.6963C16.713 10.4899 15.8628 9.6975 14.7824 10.6293L14.1986 11.1364C13.7211 11.4822 12.3864 12.6063 12.0626 14.7418C11.6729 17.3041 12.9021 20.2383 15.7183 23.4577C18.5309 26.6786 21.2848 28.2964 23.8933 28.2682C26.0613 28.2449 27.3705 27.0885 27.78 26.668L28.3659 26.1602C29.4435 25.2291 28.774 24.2811 27.6766 23.3464L27.017 22.7823Z",
    fill: "#ACACAC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call_icon.23eebb16b78151078452a0831143bb6a.svg";
export { ForwardRef as ReactComponent };